// components/UiComponents/DecimalInput.jsx
import React from 'react';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const DecimalInput = ({
  value,
  onChange,
  label,
  required = false,
  id = 'decimal-input',
  decimalSeparator = '.',
  maxDecimalDigits = 2,
  unit = '',
  fullWidth = true,
  ...props
}) => {
  const handleChange = (e) => {
    let input = e.target.value.replace(decimalSeparator === ',' ? ',' : '.', '.');

    // Geçerli sayı mı kontrol et
    if (!/^\d*\.?\d*$/.test(input)) return;

    // Ondalık basamak sayısı kontrolü
    const parts = input.split('.');
    if (parts.length === 2 && parts[1].length > maxDecimalDigits) return;

    onChange(input);
  };

  const displayValue = value?.toString().replace('.', decimalSeparator);

  return (
    <TextField
      required={required}
      id={id}
      label={label}
      type="text"
      value={displayValue}
      onChange={handleChange}
      fullWidth={fullWidth}
      slotProps={{
        input: {
          inputMode: 'decimal',
          pattern: '[0-9]*[.,]?[0-9]*',
          endAdornment: unit ? <InputAdornment position="end">{unit}</InputAdornment> : undefined
        }
      }}
      {...props}
    />
  );
};

export default DecimalInput;